import { render, staticRenderFns } from "./messageSentList.vue?vue&type=template&id=6262c96d&scoped=true&"
import script from "./messageSentList.vue?vue&type=script&lang=js&"
export * from "./messageSentList.vue?vue&type=script&lang=js&"
import style0 from "./messageSentList.vue?vue&type=style&index=0&id=6262c96d&lang=scss&scoped=true&"
import style1 from "./messageSentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262c96d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
